'use strict';

function ChooseStatesTemplateDialogController(
  $scope,
  $mdDialog,
  statesTemplates
) {
  'ngInject';

  $scope.statesTemplates = statesTemplates;

  $scope.selectedStatesTemplate = function(st) {
    $mdDialog.hide(st);
  };

  $scope.querySearch = function(text) {
    const matches = this.statesTemplates.filter(
      st => st.name.toLowerCase().indexOf(text.toLowerCase()) > -1
    );
    return matches;
  };

  $scope.cancel = function() {
    $mdDialog.cancel();
  };
}

export default ChooseStatesTemplateDialogController;
